import { render, staticRenderFns } from "./TemplateMessagesTable.vue?vue&type=template&id=6a6b9772&"
import script from "./TemplateMessagesTable.vue?vue&type=script&lang=js&"
export * from "./TemplateMessagesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports